import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import BrandLogo from "./BrandLogo";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/about", label: "品牌介绍" },
  { to: "/news", label: "产品资讯" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const transparent = !scrolled && !menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur-md border-b border-background-200"
      }`}
    >
      <nav className="w-full h-[72px] px-4 md:px-10 flex items-center justify-between">
        <BrandLogo light={transparent} />

        <ul className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `relative px-5 py-2 text-sm font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? transparent
                        ? "text-background-50 bg-background-50/15"
                        : "text-primary-600 bg-primary-100"
                      : transparent
                      ? "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <NavLink
            to="/contact"
            className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-send-line text-base leading-none"></i>
            商务合作
          </NavLink>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer transition-colors ${
            transparent ? "text-background-50 bg-background-50/15" : "text-foreground-900 bg-background-100"
          }`}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-2xl leading-none`}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-6 pt-2">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-primary-100 text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <NavLink
            to="/contact"
            className="mt-3 flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer"
          >
            <i className="ri-mail-send-line text-base leading-none"></i>
            商务合作
          </NavLink>
        </div>
      )}
    </header>
  );
}